import {
    FETCH_PROFILE_OBJECTS,
    PROFILE_OBJECT_REMOVE,
    PROFILE_OBJECT_REORDER,
    PROFILE_OBJECT_RESET,
    PROFILE_OBJECT_TOGGLE_SELECT,
    PROFILE_OBJECT_UPDATE
} from '../actions/actionTypes';

import { patchItem, removeItem } from '../helpers/collections';

const initialState = {
    order:                 'asc',
    orderBy:               'name',
    profileObjects:        [],
    selectedProfileObject: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PROFILE_OBJECTS:
            return {
                ...state,
                profileObjects: [...action.payload]
            };
        case PROFILE_OBJECT_REMOVE:
            return {
                ...state,
                profileObjects: removeItem(state.profileObjects, action.payload.id)
            };
        case PROFILE_OBJECT_REORDER:
            return {
                ...state,
                ...action.payload
            };
        case PROFILE_OBJECT_RESET:
            return {
                ...initialState
            };
        case PROFILE_OBJECT_TOGGLE_SELECT:
            return {
                ...state,
                profileObjects: patchItem(
                    state.profileObjects,
                    action.payload.id,
                    ({ isSelected }) => ({
                        isSelected: !isSelected
                    })
                )
            };
        case PROFILE_OBJECT_UPDATE: {
            let profileObjects = state.profileObjects;
            if (!action.payload.id) {
                // Add new profile object
                profileObjects = [
                    ...profileObjects,
                    action.payload.patch
                ];
            } else {
                // Update existing profile object
                profileObjects = patchItem(
                    state.profileObjects,
                    action.payload.id,
                    action.payload.patch
                );
            }
            return {
                ...state,
                profileObjects
            };
        }
        default:
            return state;
    }
};
